import React from 'react';
import {ServerComponentCaller} from "../../helpers";

const DS962018 = props => <ServerComponentCaller url={"assets/data/pages/DS962018.json"}/>;

export default DS962018;
